import React from 'react'
import Spinner from 'react-bootstrap/Spinner';

const Loader = ({isLoading, animation, variant, size, ...props}) => {
  return (
    <div {...props} >
        <Spinner {...{animation, variant, size}} />
    </div>
  )
}

export default Loader